import { useNavigate } from "react-router-dom";
import { ARCInfo } from "arcjs/common/arc_devices";
import AnimatedModal from "components/layout/motion/AnimatedModal";

interface Props {
    arc: ARCInfo | null;
    proxyHostname: string | null;
    visible: boolean;
    onClose: () => void;
}

const ControlARCDialog = ({ arc, proxyHostname, visible, onClose }: Props) => {
    const navigate = useNavigate();

    const handleConfirm = () => {
        if (!arc) return;
        navigate(`/fleet/arc/${arc.serialNumber}/control`);
    };

    return (
        <AnimatedModal
            visible={visible}
            onClose={onClose}
            className="w-full max-w-sm rounded-r10 bg-black80 p-6"
        >
            {arc && (
                <>
                    <h2 className="text-h4 font-medium text-white">
                        Control {arc.name || arc.serialNumber}?
                    </h2>
                    {arc.name && arc.name !== arc.serialNumber && (
                        <p className="text-h5 text-black40">{arc.serialNumber}</p>
                    )}
                    <div className="mb-2" />
                    {!proxyHostname && (
                        <p className="text-h5 text-yellow-400 mb-3">
                            No proxy assigned to your org — connection may fail.
                        </p>
                    )}
                    <div className="flex justify-end gap-2 mt-4">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 text-h5 text-black40 hover:text-white"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleConfirm}
                            className="px-4 py-2 text-h5 bg-primary2 text-white rounded-r5"
                        >
                            Control
                        </button>
                    </div>
                </>
            )}
        </AnimatedModal>
    );
};

export default ControlARCDialog;
